export enum ETypes {
  DIGITAL = 1,
  SERVICE = 2,
  PHYSICAL = 3,
  TICKET = 4,
}

export interface ICurrency {
  id: number;
  name: string;
  code: 'BRL' | 'USD' | 'EUR' | 'GBP';
}

export enum EChargeType {
  SINGLE = 'N',
  SUBSCRIPTION = 'A',
  OTHER = 'L',
  FREE = 'G',
}

export enum ECommissionType {
  PERCENTAGE = 'P',
  VALUE = 'V',
}

export const commissionTypes = [
  { label: 'Porcentagem', value: ECommissionType.PERCENTAGE },
  { label: 'Valor', value: ECommissionType.VALUE },
];

export interface IMaterial {
  type: 'l' | 'm';
  link: string;
  file_id: number;
  file_name: string;
  description: string;
}

class Product {
  id: number;
  has_children: boolean;
  title: string;
  description: string;
  image_id: number;
  image_url: string;
  expiration_date: string;
  has_expiration_date: boolean;
  sales_recovery: boolean;
  allows_boleto: boolean;
  allows_paypal: boolean;
  allows_card: boolean;
  allows_multiple_cards: boolean;
  comission_type: ECommissionType;
  comission_value: number;
  recurring_comission_type: ECommissionType;
  recurring_comission_value: number;
  membership_comission_type: ECommissionType;
  membership_comission_value: number;
  comission_on_first_invoice: boolean;
  charge_type: EChargeType;
  currency: ICurrency;
  price: number;
  recurring_value: number;
  recurring_frequency_type: string;
  recurring_frequency: number;
  undetermined_charges: boolean;
  limit_charges: number;
  overdue_limit: number;
  permanent_access: boolean;
  membership_fee: boolean;
  membership_price: number;
  has_trial: boolean;
  trial_days: number;
  visible: boolean;
  auto_affiliation: boolean;
  infinity_funnel: boolean;
  recruit: boolean;
  recruit_commission_type: ECommissionType;
  recruit_commission_value: number;
  recruit_max_sales: number;
  funnel_commission: number;
  affiliate_instructions: string;
  affiliation_contract: string;
  type: ETypes;
  author_name: string;
  alternative_url: string;
  refund_days: number;
  prelaunch: boolean;
  launch_date: Date;
  sales_expectation: number;
  program_content: string;
  support_email: string;
  categories: any[];
  url_thankyou_card: string;
  url_thankyou_boleto: string;
  name_extract_description: string;
  recovery_email: string;
  thankyou_type: number;
  webhook_type: string;
  webhook: boolean;
  webhook_url: string;
  parent_product: number;
  friendly_name: string;
  unlimited_installment: boolean;
  parent_id: number;
  deliver_first_charge: boolean;
  deliveries: Array<any>;
  physicalDelivery: any;
  stock: number;
  notify_stock: number;
  recurring_start_charging: string;
  recurring_days_start_charging: number;
  document_on_checkout: boolean;
  email_welcome: boolean;
  ask_address_checkout: boolean;
  ask_address_thanks: boolean;
  hide_quantity: boolean;
  url_checkout: string;
  is_producer: boolean;
  moderation_status: string;
  default_sales_page: string;
  yearly_installment: boolean;
  producer_id: number;
  remove_access: boolean;
  has_promotional_price: boolean;
  promotional_price: number;
  date_promotional_price: string;
  allow_installment_checkout: boolean;
  materials: IMaterial[];
  send_billing_reminder: boolean;

  constructor(private product: Product) {
    this.id = this.product.id || 0;
    this.has_children = this.product.has_children || false;
    this.title = this.product.title || '';
    this.description = this.product.description || '';
    this.image_id = this.product.image_id || null;
    this.image_url = this.product.image_url || null;
    this.expiration_date = this.product.expiration_date || null;
    this.has_expiration_date = this.product.has_expiration_date || false;
    this.sales_recovery = this.product.sales_recovery || false;
    this.allows_boleto = this.product.allows_boleto || false;
    this.allows_paypal = this.product.allows_paypal || false;
    this.allows_card = this.product.allows_card || false;
    this.allows_multiple_cards = this.product.allows_multiple_cards || false;
    this.comission_type = this.product.comission_type || ECommissionType.PERCENTAGE;
    this.comission_value = this.product.comission_value || 0;
    this.recurring_comission_type = this.product.recurring_comission_type || ECommissionType.PERCENTAGE;
    this.recurring_comission_value = this.product.recurring_comission_value || 0;
    this.membership_comission_type = this.product.membership_comission_type || ECommissionType.PERCENTAGE;
    this.membership_comission_value = this.product.membership_comission_value || 0;
    this.comission_on_first_invoice = this.product.comission_on_first_invoice || false;
    this.charge_type = this.product.charge_type || EChargeType.SINGLE;
    this.currency = this.product.currency || null;
    this.price = this.product.price || 0;
    this.recurring_value = this.product.recurring_value || 0;
    this.recurring_frequency_type = this.product.recurring_frequency_type || 'M';
    this.recurring_frequency = this.product.recurring_frequency || 1;
    this.undetermined_charges = this.product.undetermined_charges;
    this.limit_charges = this.product.limit_charges || 2;
    this.overdue_limit = this.product.overdue_limit || 5;
    this.permanent_access = this.product.permanent_access || true;
    this.membership_fee = this.product.membership_fee || false;
    this.membership_price = this.product.membership_price || 0;
    this.has_trial = this.product.has_trial || false;
    this.trial_days = this.product.trial_days || 1;
    this.visible = this.product.visible || false;
    this.auto_affiliation = this.product.auto_affiliation || false;
    this.infinity_funnel = this.product.infinity_funnel || false;
    this.recruit = this.product.recruit || false;
    this.recruit_commission_type = this.product.recruit_commission_type || ECommissionType.PERCENTAGE;
    this.recruit_commission_value = this.product.recruit_commission_value || 0;
    this.recruit_max_sales = this.product.recruit_max_sales || 0;
    this.funnel_commission = this.product.funnel_commission || 50;
    this.affiliate_instructions = this.product.affiliate_instructions || '';
    this.affiliation_contract = this.product.affiliation_contract || '';
    this.type = this.product.type || ETypes.DIGITAL;
    this.author_name = this.product.author_name || '';
    this.alternative_url = this.product.alternative_url || '';
    this.refund_days = this.product.refund_days;
    this.prelaunch = this.product.prelaunch || false;
    this.launch_date = this.product.launch_date || null;
    this.sales_expectation = this.product.sales_expectation || 0;
    this.program_content = this.product.program_content || '';
    this.support_email = this.product.support_email || '';
    this.categories = this.product.categories || [];
    this.url_thankyou_card = this.product.url_thankyou_card || '';
    this.url_thankyou_boleto = this.product.url_thankyou_boleto || '';
    this.name_extract_description = this.product.name_extract_description || '';
    this.recovery_email = this.product.recovery_email || '';
    this.thankyou_type = this.product.thankyou_type || 3;
    this.webhook_type = this.product.webhook_type || 'E';
    this.webhook = this.product.webhook || false;
    this.webhook_url = this.product.webhook_url || '';
    this.parent_product = this.product.parent_product || null;
    this.friendly_name = this.product.friendly_name || '';
    this.unlimited_installment = this.product.unlimited_installment || false;
    this.parent_id = this.product.parent_product || null;
    this.deliver_first_charge = this.product.deliver_first_charge || false;
    this.deliveries = this.product.deliveries || [];
    this.physicalDelivery = this.product.physicalDelivery || null;
    this.stock = this.product.stock || 0;
    this.notify_stock = this.product.notify_stock || 0;
    this.recurring_start_charging = this.product.recurring_start_charging || '';
    this.recurring_days_start_charging = this.product.recurring_days_start_charging || null;
    this.document_on_checkout = this.product.document_on_checkout || false;
    this.email_welcome = this.product.email_welcome || false;
    this.ask_address_checkout = this.product.ask_address_checkout || false;
    this.ask_address_thanks = this.product.ask_address_thanks || false;
    this.hide_quantity = this.product.hide_quantity || false;
    this.url_checkout = this.product.url_checkout || '';
    this.is_producer = this.product.is_producer || false;
    this.moderation_status = this.product.moderation_status || '';
    this.default_sales_page = this.product.default_sales_page || '';
    this.yearly_installment =
      this.product.yearly_installment && (this.product.recurring_frequency_type === 'Y' || this.product.recurring_frequency_type === 'SM')
        ? true
        : false;
    this.producer_id = this.product.producer_id || 0;
    this.remove_access = this.product.remove_access || false;
    this.has_promotional_price = this.product.has_promotional_price || false;
    this.promotional_price = this.product.promotional_price || 0;
    this.date_promotional_price = this.product.date_promotional_price || '';
    this.allow_installment_checkout = this.product.allow_installment_checkout || false;
    this.materials = this.product.materials || [];
    this.send_billing_reminder = this.product.send_billing_reminder || false;
  }
}

export default Product;
